module.exports = __webpack_public_path__ + "static/media/ipl.48555d26.png";